export const initialise = () => {
    if (!document.body.classList.contains('page-job-details')) return
    const stickyApply = document.querySelector<HTMLElement>('.sticky-apply')
    if (!stickyApply) return

    createStickyApplyHeading(stickyApply)
    showStickyApply(stickyApply)
}

export const createStickyApplyHeading = (stickyApply: HTMLElement) => {
    const jobTitle = document.querySelector<HTMLElement>('.title-widget .header__text')
    const stickyHeading = stickyApply.querySelector<HTMLElement>('.stick-apply__heading')

    if (!jobTitle || !stickyHeading) return

    stickyHeading.innerText = jobTitle.innerText
}

export const showStickyApply = (stickyApply: HTMLElement) => {
    const hero = document.querySelector<HTMLElement>('.page-job-details__hero')
    if (!hero) return

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (!entry.isIntersecting) {
                stickyApply.classList.add('sticky-apply--visible')
            } else {
                stickyApply.classList.remove('sticky-apply--visible')
            }
        }, { threshold: 0 }
    )

    observer.observe(hero)
}
